import { AuthContext, AuthContextProvider } from "../contexts/auth-context";
import useContextWrapper from "./useContextWrapper";

const useAuth = () =>
useContextWrapper(AuthContext, {
  contextName: useAuth.name,
  providerName: AuthContextProvider.name
});

export default useAuth;